var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TfMenuItem',{key:_vm.url,class:{'sub-page': !_vm.children || _vm.children.length === 0},attrs:{"index":_vm.url}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]),_vm._l((_vm.children),function(child){return _c('ExampleMenuItem',{key:child.url,attrs:{"url":child.url,"text":child.text,"children":child.children}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }